import {defineSlotRecipe} from '@chakra-ui/react3'

export const galleryRecipe = defineSlotRecipe({
    slots: ['moduleContainer', 'textContainer'],
    base: {
        moduleContainer: {
            display: 'flex',
            flexDirection: 'column',
            align: 'start'
        },
        textContainer: {
            textAlign: {base: 'left', s: 'center'},
            gap: 'spacing-16',
            flexDirection: 'column'
        }
    }
})

export const slideRecipe = defineSlotRecipe({
    slots: ['root', 'textContainer', 'headline', 'copy', 'topLayer', 'bottomLayer'],
    base: {
        root: {
            flexDirection: 'column',
            borderRadius: {base: 0, s: 'm'},
            overflow: 'hidden'
        },
        textContainer: {
            zIndex: 2,
            position: {base: 'relative', s: 'absolute'},
            paddingTop: {s: 'spacing-32'},
            paddingBottom: {base: 'spacing-40', s: 'spacing-32'},
            paddingX: {base: 'spacing-24', xs: 'spacing-48', s: 'spacing-32'},
            maxWidth: {base: '100%', s: '25.5rem'}
        },
        headline: {
            color: {base: 'text.primary', s: 'text.on-surface'},
            pb: 'spacing-8'
        },
        topLayer: {
            position: 'absolute',
            zIndex: 1,
            width: '100%',
            height: 'calc(40% + 2px)', // to avoid getting a 1px black line at the bottom
            top: 0,
            pointerEvents: 'none'
        },
        bottomLayer: {
            position: 'absolute',
            background: 'gradient.bottom.darken-100',
            zIndex: 1,
            width: '100%',
            height: '50%',
            bottom: 0,
            pointerEvents: 'none'
        }
    },
    variants: {
        darken: {
            0: {topLayer: {background: 'gradient.top.darken-0'}},
            40: {topLayer: {background: 'gradient.top.darken-40'}},
            80: {topLayer: {background: 'gradient.top.darken-80'}},
            100: {topLayer: {background: 'gradient.top.darken-100'}}
        }
    }
})
